export default __webpack_public_path__ + "static/media/job-switching-arrow-right-skyblue.19739c72.svg";